/**
 * Drawer Filters - JavaScript
 * Gère le comportement du menu drawer de filtres avec style moderne
 */
class FiltersDrawer {
  constructor() {
    this.drawer = document.getElementById('drawer-filters');
    this.overlay = document.querySelector('.drawer-filters-overlay');
    this.form = document.getElementById('DrawerFilterForm');

    // Si les éléments n'existent pas, ne pas initialiser
    if (!this.drawer) return;

    this.init();
  }

  init() {
    this.setupEventListeners();
    this.updateSelectionClasses();
    this.setupSearchFilter();
  }

  updateSelectionClasses() {
    // Mise à jour des classes CSS pour les options sélectionnées
    const checkboxes = this.drawer.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((checkbox) => {
      const parent = checkbox.closest('.option-button, .size-option, .category-option');
      if (parent) {
        if (checkbox.checked) {
          parent.classList.add('selected');
        } else {
          parent.classList.remove('selected');
        }
      }
    });
  }

  setupSearchFilter() {
    const searchInput = document.getElementById('drawer-filters-search');
    if (!searchInput) return;

    // Ajouter un gestionnaire pour la touche Entrée
    searchInput.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        this.applyFilters();
      }
    });
  }

  filterOptions(selector, query) {
    document.querySelectorAll(selector).forEach((label) => {
      const labelText = label.getAttribute('data-filter-label') || '';
      if (labelText.includes(query) || query === '') {
        label.style.display = '';
      } else {
        label.style.display = 'none';
      }
    });
  }

  setupEventListeners() {
    // Gérer les clics sur les boutons et l'overlay
    document.addEventListener('click', (event) => {
      const element = event.target.closest('[data-action]');
      if (!element) return;

      const action = element.getAttribute('data-action');

      switch (action) {
        case 'open-filters-drawer':
          this.openDrawer();
          break;
        case 'close-filters-drawer':
          this.closeDrawer();
          break;
        case 'apply-drawer-filters':
          this.applyFilters();
          break;
        case 'clear-drawer-filters':
          this.clearFilters();
          break;
      }
    });

    // Gérer les changements de filtres
    if (this.form) {
      const inputs = this.form.querySelectorAll('input[type="checkbox"], input[type="radio"]');
      inputs.forEach((input) => {
        input.addEventListener('change', () => {
          this.updateSelectionClasses();
          this.applyFilters(); // applique les filtres dès qu'on coche/decoche
        });
      });

    }

    // Fermer le drawer quand on clique sur Escape
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.isDrawerOpen()) {
        this.closeDrawer();
      }
    });

    const searchBtn = this.drawer.querySelector('.drawer-filters__search-button');
    if (searchBtn) {
      searchBtn.addEventListener('click', () => {
        this.applyFilters();
      });
    }
  }

  isDrawerOpen() {
    return this.drawer.hasAttribute('data-open');
  }

  openDrawer() {
    this.drawer.setAttribute('data-open', '');
    this.overlay.setAttribute('data-open', '');
    document.body.style.overflow = 'hidden'; // Empêcher le défilement du body
  }

  closeDrawer() {
    this.drawer.removeAttribute('data-open');
    this.overlay.removeAttribute('data-open');
    document.body.style.overflow = ''; // Réactiver le défilement
  }

  applyFilters() {
    if (!this.form) return;

    const formData = new FormData(this.form);
    const searchParams = new URLSearchParams();

    // Traiter tous les filtres cochés
    let sizeFilterSelected = false;

    this.form.querySelectorAll('input[type="checkbox"]:checked').forEach((input) => {
      const name = input.name;
      const value = input.value;

      // Si une taille est sélectionnée
      if (name.includes('filter.v.option.taille')) {
        sizeFilterSelected = true;
      }

      searchParams.append(name, value);
    });

    // Si une taille est sélectionnée, forcer le filtre "En stock"
    if (sizeFilterSelected) {
      searchParams.set('filter.v.availability', '1');
    }

    // Traiter explicitement la valeur de recherche
    const searchInput = document.getElementById('drawer-filters-search');
    if (searchInput && searchInput.value.trim()) {
      searchParams.set('q', searchInput.value.trim());
    }

    // Conserver les paramètres de tri existants
    const currentUrl = new URL(window.location.href);
    const currentParams = new URLSearchParams(currentUrl.search);

    if (currentParams.has('sort_by')) {
      searchParams.set('sort_by', currentParams.get('sort_by'));
    }

    // Construction de l'URL
    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;

    // Votre code AJAX existant
    fetch(newUrl, {
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'text/html, */*' },
      credentials: 'same-origin',
    })
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newGridList = doc.querySelector('.product-grid-product-list');
        const currentGridList = document.querySelector('.product-grid-product-list');

        if (newGridList && currentGridList) {
          currentGridList.innerHTML = newGridList.innerHTML;

          // Synchroniser la pagination avec les résultats filtrés
          const newPagination = doc.querySelector('.mx-product-grid-pagination');
          const currentPagination = document.querySelector('.mx-product-grid-pagination');

          if (currentPagination && newPagination) {
            currentPagination.innerHTML = newPagination.innerHTML;
          } else if (currentPagination) {
            currentPagination.remove();
          } else if (newPagination) {
            currentGridList.insertAdjacentElement('afterend', newPagination);
          }

          window.history.replaceState({}, '', newUrl);
        }
         else {
          window.location.href = newUrl;
        }
      })
      .catch(() => {
        window.location.href = newUrl;
      });
  }

  clearFilters() {
    if (!this.form) return;

    // Décocher toutes les cases à cocher
    const checkboxes = this.form.querySelectorAll('input[type="checkbox"]:checked');
    checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });

    // Effacer les champs de texte
    const textInputs = this.form.querySelectorAll('input[type="text"], input[type="number"]');
    textInputs.forEach((input) => {
      input.value = '';
    });

    // Mettre à jour les classes CSS
    this.updateSelectionClasses();
  }
}

// Initialiser les filtres du drawer au chargement de la page
document.addEventListener('DOMContentLoaded', () => {
  new FiltersDrawer();

  // Scroll horizontal à la molette pour les tailles
  document.querySelectorAll('.drawer-filters__size-options').forEach((el) => {
    el.addEventListener(
      'wheel',
      function (e) {
        if (e.deltaY !== 0) {
          e.preventDefault();
          el.scrollLeft += e.deltaY;
        }
      },
      { passive: false },
    );
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.getElementById('drawer-filters-search');
  const productList = document.querySelector('.product-grid-product-list');
  if (!searchInput || !productList) return;

  function filterProducts() {
    const query = searchInput.value.trim().toLowerCase();
    const products = productList.querySelectorAll('.product-grid-product-container');

    products.forEach((product) => {
      // On récupère le titre du produit (à adapter selon ton HTML)
      const titleEl = product.querySelector('.product-card__title, .mx-product-card__title, h3, h2');
      const title = titleEl ? titleEl.textContent.trim().toLowerCase() : '';

      if (query === '' || title.includes(query)) {
        product.style.display = '';
      } else {
        product.style.display = 'none';
      }
    });
  }

  // Filtrer à chaque frappe ou lors du clic sur "Appliquer"
  searchInput.addEventListener('input', filterProducts);
  searchInput.addEventListener('input', applyMotifToGrid);

  // Si tu veux filtrer aussi au clic sur le bouton "Appliquer"
  const applyBtn = document.querySelector('.drawer-filters__apply-button');
  if (applyBtn) {
    applyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      filterProducts();
    });
  }
});

const motif = [3, 2, 3];
function applyMotifToGrid() {
  const items = document.querySelectorAll('.product-grid-product-container');
  let i = 0;
  let motifIndex = 0;
  while (i < items.length) {
    const count = motif[motifIndex % motif.length];
    for (let j = 0; j < count && i < items.length; j++, i++) {
      items[i].classList.remove('col-2', 'col-3');
      items[i].classList.add('col-' + count);
    }
    motifIndex++;
  }
}
